const serviceUrl = `${__configuration.apiUrl}/massia/factures-x`;

export default class FacturesXService {
	static $inject = ['$http', 'notification', '$window', '$translate'];

	constructor($http, notification, $window, $translate) {
		this.$http = $http;
		this.notification = notification;
		this.$window = $window;
		this.$translate = $translate;
	}

	async getGridConfig(profile = 'DEFAULT') {
		const url = `${serviceUrl}/grid-config?profile=${profile}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async downloadFactureX(id, code) {
		try {
			const url = `${serviceUrl}/download-facture-x/${id}`;
			const result = await this.$http.get(url, { responseType: 'arraybuffer' });
			const blob = new Blob([result.data], { type: 'application/pdf' });
			const urlPdf = this.$window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = urlPdf;
			link.download = `FactureX_${code}.pdf`;
			link.click();
			this.$window.URL.revokeObjectURL(urlPdf);
		} catch (ex) {
			// const error = ex as { data?: string; message?: string };
			this.notification.error(this.$translate.instant('FACTURES.DOWNLOAD_ERROR'));
			console.log('FacturesXService ~ downloadFacturesX ~ ex:', ex);
		}
	}

	async deleteFactureX(id) {
		const url = `${serviceUrl}/delete-facture-x/${id}`;
		const result = await this.$http.post(url);
		return result.data;
	}

	async downloadListFactureX(ids) {
		try {
			const url = `${serviceUrl}/download-list-facture-x`;
			const result = await this.$http.post(url, ids, { responseType: 'arraybuffer' });
			const blob = new Blob([result.data], { type: 'application/zip' });
			const urlPdf = this.$window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = urlPdf;
			link.download = `FacturesX.zip`;
			link.click();
			this.$window.URL.revokeObjectURL(url);
		} catch (ex) {
			// const error = ex as { data?: string; message?: string };
			this.notification.error(this.$translate.instant('FACTURES.DOWNLOAD_ERROR'));
			console.log('FacturesXService ~ downloadListFactureX ~ ex:', ex);
		} finally {
			this.loading = false;
		}
	}

	async deleteListFactureX(ids) {
		const url = `${serviceUrl}/delete-list-facture-x`;
		const result = await this.$http.post(url, ids, { responseType: 'arraybuffer' });
		return result.data;
	}

	async sendFactureX(id) {
		const url = `${serviceUrl}/send-facture-x/${id}`;
		const result = await this.$http.post(url);
		return result.data;
	}

	async generateFactureX(factureIds) {
		const url = `${serviceUrl}/generate-facture-x`;
		const result = await this.$http.post(url, factureIds);
		return result.data;
	}

	async generateFactureXUnitaire(id) {
		const url = `${serviceUrl}/generate-facture-x/${id}`;
		const result = await this.$http.post(url);
		return result.data;
	}

	async getFacturesXStatus(factureIds) {
		const url = `${serviceUrl}/status`;
		const result = await this.$http.post(url, factureIds);
		return result.data;
	}

	async getDataByDomaine(domaine) {
		const url = `${serviceUrl}/data-by-domaine/${domaine}`;
		const result = await this.$http.get(url);
		return result.data;
	}
}
